module.exports = __webpack_public_path__ + "static/neptuneLogo-5e14fd29d4cc7807ccbbacf5547f42f0.svg";